import refreshCaptcha from "../utils/captcha-refresh";

const form4 = document.querySelector('#gform_4');
let requiredElementsTab = [];

document.addEventListener("DOMContentLoaded", () => {
    displayContactFormOnClick();

    jQuery('#input_4_33').inputmask({
        mask: '',
        regex: "^[0-9]{0,100}$",
        showMaskOnHover: false,
        showMaskOnFocus: false,
    });

    if('undefined'!=typeof(form4) && !!form4) {
        const requiredElements = form4.querySelectorAll('[aria-required="true"]');
        requiredElements.forEach((element)=>{
            requiredElementsTab.push(element.id.split('_')[2]);
        });
        requiredElementsTab.push('22.1');

        let getNextSibling = function (elem, selector){
            let sibling = elem.nextElementSibling;
            if (!selector) return sibling;
            while (sibling) {
                if (sibling.matches(selector)) return sibling;
                sibling = sibling.nextElementSibling
            }
        };

        gform.addAction( 'gform_input_change', ( elem, formId, fieldId )=>{
            if(4!=formId) return;
            let validationMessage = getNextSibling(elem.parentNode,'.gfield_validation_message');

            if(requiredElementsTab.includes(fieldId)) {

                if('checkbox'==elem.type) {

                    if(elem.checked) {
                        (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                        elem.setAttribute("aria-invalid", "false");
                    } else {
                        (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                        elem.setAttribute("aria-invalid", "true");
                    }

                } else {

                    if(elem.value.length>0) {
                        (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                        elem.setAttribute("aria-invalid", "false");
                    } else {
                        (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                        elem.setAttribute("aria-invalid", "true");
                    }

                }

            }

        },10,3);

    }

});

function displayContactFormOnClick() {
    const buttonClick = document.querySelectorAll('#trigger-contact-form');
    const formShow = document.querySelector('#gform_wrapper_4');
    const beforeFormText = document.querySelector('.bsct-table-info-grid');
    const pageID = document.querySelectorAll('.page-id-327, .page-id-38135');

    if (pageID) {
        if (!formShow) return;

        formShow.classList.add('d-none');
        beforeFormText.classList.add('d-none');

        buttonClick.forEach(btn => {
            btn.addEventListener('click', () => {
                formShow.classList.remove('d-none');
                formShow.classList.add('d-block');
                beforeFormText.classList.remove('d-none');
                beforeFormText.classList.add('d-block');

                beforeFormText.scrollIntoView({behavior: "smooth", block: "start"});
            });
        });

        refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');

        jQuery('#input_4_12').inputmask({
            mask: '',
            placeholder: '',
            regex: "[a-zA-Z0-9]*",
            showMaskOnHover: false,
            showMaskOnFocus: false,
        });
    }
}

jQuery( document ).ready(function() {
    jQuery(document).bind('gform_post_render', ()=>{
        refreshCaptcha('.pp-captcha__code-refresh', '.pp-captcha__code-img');
    });
});

